import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";

import { getOrganization } from "./getOrganization.thunk";

import type {
  DeleteOrganizationProps,
  DeleteOrganizationFulfilled
} from "../types";
import type { Organization } from "@packages/client";
import type { AsyncThunkOptionType } from "Reducers/types";

export const deleteOrganization = createAsyncThunk<
  DeleteOrganizationFulfilled,
  DeleteOrganizationProps,
  AsyncThunkOptionType
>(
  "app/organizations/delete_organization",
  async ({ organizationDescriptionId }, { rejectWithValue, dispatch }) => {
    try {
      const orgResponse = await dispatch(
        getOrganization({
          organizationDescriptionId
        })
      );
      const organizationToDelete: Organization =
        orgResponse?.payload?.organization;

      await organizationToDelete?.delete();

      return organizationToDelete;
    } catch (err) {
      logger(err, {
        action: "deleteOrganization",
        organizationDescriptionId
      });

      return rejectWithValue(err);
    }
  }
);
